module.exports = __webpack_public_path__ + "img/mobile-5.0c1924ef.jpg";